<!-- 邀请函管理 -->
<template>
  <div class="menu-item-r">
    <div class="bl-container bg-view">
      <div class="history-title">{{$t('clientPool.exhibitor_invitation_record2')}}</div>
      <div class="history-desc">{{$t('clientPool.only_visitors')}}</div>
      <el-table class="history-table" :data="list" :header-cell-style="{background: '#F1F1F1'}" v-loading="loading">
        <el-table-column :label="$t('clientPool.audience_name')"  prop="name" align="center"></el-table-column>
        <el-table-column :label="$t('clientPool.email')" prop="email" align="center"></el-table-column>
        <el-table-column :label="$t('clientPool.invitation_date')" prop="createTime" align="center">
          <template slot-scope="scope">
            {{scope.createTime}}
            {{getDateStr(scope.row.createTime)}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('clientPool.status')" prop="registerStatus" align="center">
          <template slot-scope="scope">
            {{scope.row.registerStatus ? $t('Yes') : $t('No')}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('clientPool.register_date')" prop="updateTime" align="center">
          <template slot-scope="scope">
            {{getDateStr(scope.row.updateTime)}}
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          @current-change="pageChange"
          :page-size="pageSize"
          :current-page="page"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { getRecordPage } from '../../api/clientPool.js'
import { dateFormat } from '@/utils/function'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      page: 1,
      total: 0,
      pageSize: 10,
      loading: false,
      list: []
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    getData() {
      var params = {
        pageNum: this.page,
        pageRows: this.pageSize
      }
      this.loading = true;
      getRecordPage(params).then(res => {
        return res.data
      }).then(res => {
        this.loading = false;
        if (res.code === 1000) {
         this.total = res.data.total;
         this.list = res.data.list;
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    pageChange(page) {
      this.page = page;
      this.getData();
    },
    getDateStr(time) {
      if (!time) {
        return '--'
      }
      var date = new Date(time);
      var dateStr = dateFormat(date, 'YYYY-mm-dd');
      return dateStr;
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.getData();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {},
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="stylus">
.el-table__header-wrapper {
  background-color : #F1F1F1;
}
</style>
<style lang="stylus" scoped>
.bg-view {
  background: #FBFBFB;
  margin : 30px 0px;
  padding: 30px 15px;
  .history-title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: $color-black-65;
  }
  .history-desc {
    margin-top: 4px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: $color-black-45;
  }
  .history-table {
    margin-top: 24px;
  }
  .pagination {
    margin-top: 32px;
    text-align : right;
  }
}
</style>
